/* לקוח HTTP מרכזי. כל תקשורת עם השרת עוברת דרכו. */

/* כתובת בסיס ל-API. ריקה בברירת מחדל — הבקשות יוצאות לאותו מקור. */
const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? '';
const GENERIC_REQUEST_ERROR = 'אירעה שגיאה בשליחה, נסו שוב מאוחר יותר.';

export class ApiError extends Error {
  readonly status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

interface RequestOptions {
  method: 'GET' | 'POST';
  body?: unknown;
  signal?: AbortSignal;
}

/** מבצע קריאה ל-API ומחזיר את גוף התשובה המפוענח. */
export async function request<TResponse>(
  path: string,
  options: RequestOptions,
): Promise<TResponse> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: options.method,
    headers: { 'Content-Type': 'application/json' },
    ...(options.body === undefined ? {} : { body: JSON.stringify(options.body) }),
    ...(options.signal ? { signal: options.signal } : {}),
  });
  const payload: unknown = await response.json().catch(() => null);

  if (!response.ok) {
    /* הודעת שגיאה מהשרת מוצגת כלשונה; אחרת נוסח כללי וידידותי,
       שכן פירוט טכני אינו מסייע למשתמש ואינו אמור להיחשף לו. */
    const message =
      payload !== null &&
      typeof payload === 'object' &&
      'message' in payload &&
      typeof payload.message === 'string'
        ? payload.message
        : GENERIC_REQUEST_ERROR;

    throw new ApiError(message, response.status);
  }

  /* תשובה תקינה שאינה JSON מעידה על תקלת ניתוב (למשל HTML של ה-SPA).
     יש לזרוק שגיאה מפורשת ולא להחזיר null שיקרוס אצל הקורא. */
  if (payload === null || typeof payload !== 'object') {
    throw new ApiError('התקבלה תשובה לא צפויה מהשרת', response.status);
  }

  return payload as TResponse;
}
